import React from 'react';
import { z } from 'zod';
import { Nullable } from 'global';
import { useForm } from 'react-hook-form';
import { InputField } from 'components/form';
import { Button, Stack } from '@mui/material';
import { zodResolver } from '@hookform/resolvers/zod';

import { PresetFilter } from '../types';

interface Props<T> {
  onCancel: VoidFunction;
  preset: Nullable<PresetFilter<T>>;
  onSave: (nextValue: Pick<PresetFilter<T>, 'name'>) => Promise<void>;
}

const formSchema = z.object({
  name: z.string().min(3),
});

export const PresetsForm = <T,>({ preset, onSave, onCancel }: Props<T>) => {
  const { control, handleSubmit, formState } = useForm<z.infer<typeof formSchema>>({
    mode: 'onChange',
    resolver: zodResolver(formSchema),
    defaultValues: { name: preset?.name ?? '' },
  });

  return (
    <Stack direction="row" gap="1rem">
      <InputField
        name="name"
        control={control}
        label="Filter Name"
        inputProps={{ size: 'small', variant: 'outlined' }}
      />

      <Stack direction="row" gap="0.5rem" alignItems="center">
        <Button size="small" onClick={handleSubmit(onSave)} loading={formState.isSubmitting}>
          Save
        </Button>

        <Button size="small" color="error" onClick={onCancel}>
          Cancel
        </Button>
      </Stack>
    </Stack>
  );
};
